import { render } from "./ValidateButtonsFeedbackComponent.vue?vue&type=template&id=50182d2c&scoped=true"
import script from "./ValidateButtonsFeedbackComponent.vue?vue&type=script&lang=js"
export * from "./ValidateButtonsFeedbackComponent.vue?vue&type=script&lang=js"

import "./ValidateButtonsFeedbackComponent.vue?vue&type=style&index=0&id=50182d2c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50182d2c"]])

export default __exports__